// Corporate Actions: the routes and the sidebar rows of `wealth.ops.corporate-actions` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.corporate-actions',
    routes: [
        {
            frontend: 'ops',
            path: 'corporate-actions',
            lazy: () => import('@/pages/ops/corporate-actions/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'corporate-actions',
            label: 'Corporate Actions',
            href: '/ops/corporate-actions',
            icon: 'Building2',
            group: 'processing',
            order: 230,
        },
    ],
});
